import * as tslib_1 from "tslib";
import * as React from 'react';
import { TaskDetail } from '../pages/tasks/TaskDetail';
import TaskApi from 'src/services/TaskApi';
var TaskDialog = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDialog, _super);
    function TaskDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            _this.setState({ task: null });
            _this.props.onClose();
        };
        _this.state = {
            task: null
        };
        return _this;
    }
    TaskDialog.prototype.componentWillReceiveProps = function (nextProps) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, isOpen, taskId, shouldUpdate, task;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, isOpen = _a.isOpen, taskId = _a.taskId;
                        shouldUpdate = (!isOpen && isOpen !== nextProps.isOpen) || (taskId !== nextProps.taskId);
                        if (!shouldUpdate) return [3 /*break*/, 2];
                        return [4 /*yield*/, TaskApi.get(nextProps.taskId)];
                    case 1:
                        task = _b.sent();
                        this.setState({ task: task });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TaskDialog.prototype.render = function () {
        if (!this.props.isOpen) {
            return null;
        }
        if (!this.state.task) {
            return null;
        }
        return React.createElement(TaskDetail, { isOpen: this.props.isOpen, task: this.state.task, onClose: this.handleClose });
    };
    return TaskDialog;
}(React.Component));
export default TaskDialog;



//////////////////
// WEBPACK FOOTER
// ./src/components/TaskDialog.tsx
// module id = 308
// module chunks = 0